const setHeight = (wrapper, content) => {
	const height = content.outerHeight();
	wrapper.css('height', height + 'px');
};

export default setHeight;



/** WEBPACK FOOTER **
 ** ./app/scripts/util/dom/setHeight.js
 **/